export default __webpack_public_path__ + "static/media/tiktokIcon.8a707eb2.svg";